import { render, staticRenderFns } from "./onhold.vue?vue&type=template&id=4f166141&scoped=true"
import script from "./onhold.vue?vue&type=script&lang=js"
export * from "./onhold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f166141",
  null
  
)

export default component.exports